module.exports = __webpack_public_path__ + "662c03c7e388d9a3452b295bd881a66e.png";